exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-editor-wrapper[data-v-64a485f2] {\n  position: relative;\n}\n.password-editor-wrapper .show-password[data-v-64a485f2] {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  bottom: 3px;\n  cursor: pointer;\n}\n", ""]);

// exports
